// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--lU7l1";
export var footerCopyright = "footer-module--footer-copyright--vvv-n";
export var footerItem = "footer-module--footer-item--hCoG2";
export var footerLink = "footer-module--footer-link--el2Qe";
export var footerList = "footer-module--footer-list--eKwzX";